import { render, staticRenderFns } from "./view.html?vue&type=template&id=46906314&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=46906314&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46906314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46906314')) {
      api.createRecord('46906314', component.options)
    } else {
      api.reload('46906314', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=46906314&scoped=true&", function () {
      api.rerender('46906314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/RewardModal/index.vue"
export default component.exports